import type { Configuration, RedirectRequest } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_AAD_TENANT_ID ?? 'common';
const clientId = import.meta.env.VITE_AAD_CLIENT_ID ?? '00000000-0000-0000-0000-000000000000';
const apiScope = import.meta.env.VITE_API_SCOPE ?? 'api://keytravel-ai-gateway/access_as_user';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        else if (level === LogLevel.Warning) console.warn(message);
      },
      piiLoggingEnabled: false
    }
  }
};

export const loginRequest: RedirectRequest = {
  scopes: [apiScope]
};

export const apiScopes = [apiScope];
